module.exports = __webpack_public_path__ + "assets/avatar.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/avatar.png
// module id = 1183
// module chunks = 7